import { Component, ElementRef, Renderer2 } from '@angular/core';
import { SharedService } from '../service/shared.service';
import { ApiServiceService } from '../service/api-service.service';
import { ActivatedRoute, Router } from '@angular/router'; // Import Router for navigation
import { configuration } from 'src/configuration';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-developer-view',
  templateUrl: './developer-view.component.html',
  styleUrls: ['./developer-view.component.css']
})
export class DeveloperViewComponent {
  developer_id: string = '';
  developerViewData: any = {};
  propertyList: any = [];
  urlDeveloperName = "";
  isDeveloperValid = false;
  city: string = '';

  constructor(
    public shared: SharedService, 
    private elRef: ElementRef, 
    private renderer: Renderer2, 
    public apiService: ApiServiceService,
    public route: ActivatedRoute,
    private router: Router // Add Router for navigation
  ) {
    this.shared.isWhiteMenu = true;
  }

  ngOnInit(): void {
    this.developer_id = this.route.snapshot.params['id'];
    this.urlDeveloperName = this.route.snapshot.params['developer-name'];

    const city_id = this.route.snapshot.queryParams['city_id'];
  if (city_id) {
    this.city = city_id; // store in component variable if needed
    console.log("City from query params:", city_id);
  }
    
    if (!this.developer_id) {
      this.redirectToHome();
    } else {
      this.getData();
    }
  }

  
    async getData() {
      let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.GET_DEVELOPER_BY_ID, {
         "developer_id": this.developer_id
      })
      if (res && !res.error && res.data) {
        this.developerViewData = res.data;
        let slug = this.shared.generateUrlSlug(this.developerViewData.developer_name);
        
        if(this.urlDeveloperName && (this.urlDeveloperName != slug)) {
          if(this.shared.isBrowser()) {
            window.location.href = "/";
          }
          this.isDeveloperValid = false;
        } else {
          this.isDeveloperValid = true;
        }

        if(this.isDeveloperValid) {
          this.shared.setSEOData(this.developerViewData.developer_name, {
            description: this.developerViewData.developer_description,
            image: this.shared.getImageURL(this.developerViewData.developer_logo),
            url: environment.DOMAIN + "developer-view/" + this.developer_id + "/" + slug
          })
          this.getPropertyList();
        }
      }      
      else {
        this.redirectToHome();
      }
    }

    async getPropertyList() {
      let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.PROPERTY_LIST, {
        "developer_id": this.developer_id,
         "city_id": this.city
      });
      if (res && !res.error && res.data) {
        this.propertyList = res.data.rows;
      }
    }
  redirectToHome(): void {
    this.router.navigate(['/']); 
  }
}
